import React from 'react';
import "./Footer_black.css";
import { FaFacebook, FaInstagram, FaEnvelope ,FaYoutube,FaLinkedin} from 'react-icons/fa'; // Import the icons

function Footer_black() {
  return (
    <div className="footer_black">
      <div className="social-icons0_black">
        <a href="https://www.facebook.com/casapropriahub/" target="_blank" rel="noopener noreferrer">
          <FaFacebook />
        </a>
        <a href="https://instagram.com/casapropriahub?igshid=OGQ5ZDc2ODk2ZA%3D%3D$&utm_source=qr" target="_blank" rel="noopener noreferrer">
          <FaInstagram />
        </a>
        <a href="https://www.linkedin.com/company/casa-pr%C3%B3pria/" target="_blank" rel="noopener noreferrer">
          <FaLinkedin />
        </a>
        <a href="https://www.youtube.com/@casapropriahub"  target="_blank" rel="noopener noreferrer">
          <FaYoutube />
        </a>
        <a href="mailto:ola@casa-propria.co.mz">
          <FaEnvelope />
        </a>
      </div>
    </div>
  );
}

export default Footer_black;
